import React from "react";

// Pre-generated random positions for particles (module-load so no purity issues)
const PARTICLES = Array.from({ length: 18 }).map((_, i) => ({
  id: i,
  left: `${Math.random() * 100}%`,
  delay: `${Math.random() * 18}s`,
  duration: `${12 + Math.random() * 10}s`,
  size: `${2 + Math.random() * 4}px`,
}));

// Twinkling stars (static positions, animate via CSS)
const STARS = Array.from({ length: 24 }).map((_, i) => ({
  id: i,
  top: `${Math.random() * 100}%`,
  left: `${Math.random() * 100}%`,
  size: 1 + Math.random() * 2.5,
  delay: `${Math.random() * 5}s`,
  duration: `${3 + Math.random() * 4}s`,
}));

export default function BackgroundFX() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
      data-testid="background-fx"
    >
      {/* Soft color orbs */}
      <div
        className="orb animate-drift-slow"
        style={{
          width: 420,
          height: 420,
          top: -120,
          left: -140,
          background:
            "radial-gradient(circle, rgba(197,168,128,0.35), transparent 60%)",
        }}
      />
      <div
        className="orb animate-drift-slower"
        style={{
          width: 520,
          height: 520,
          bottom: -160,
          right: -180,
          background:
            "radial-gradient(circle, rgba(11,21,33,0.25), transparent 60%)",
        }}
      />
      <div
        className="orb animate-drift-slow"
        style={{
          width: 360,
          height: 360,
          top: "40%",
          right: "-20%",
          background:
            "radial-gradient(circle, rgba(204,180,164,0.25), transparent 60%)",
        }}
      />

      {/* Twinkling stars (subtle, scattered across viewport) */}
      {STARS.map((s) => (
        <span
          key={`s-${s.id}`}
          className="twinkle-star"
          style={{
            top: s.top,
            left: s.left,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: s.delay,
            animationDuration: s.duration,
          }}
        />
      ))}

      {/* Floating gold dust particles */}
      {PARTICLES.map((p) => (
        <span
          key={p.id}
          className="particle"
          style={{
            left: p.left,
            bottom: "-10px",
            width: p.size,
            height: p.size,
            animationDelay: p.delay,
            animationDuration: p.duration,
          }}
        />
      ))}
    </div>
  );
}
